import UploadReducer from './reducer';

export { default as UploadTypes } from './types';
export { default as UploadSelectors } from './selectors';
export { default as UploadActions } from './actions';

export default UploadReducer;
